import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'expandTrigger',
    'expandableSection',
    'expandIcon',
    'bioCollapsed',
    'bioExpanded',
    'bioToggleLabel',
  ]

  connect() {
    this.expanded = true
    if (this.hasExpandableSectionTarget) this.toggleExpanded()

    this.bioIsExpanded = false
    this.syncBioState()
  }

  toggleExpanded(e = null) {
    e?.preventDefault()
    if (!this.hasExpandableSectionTarget) return
    this.expanded = !this.expanded
    if (this.expanded) {
      this.expandableSectionTarget.classList.remove('tw-hidden')
      this.expandableSectionTarget.classList.add('grid')
      this.expandIconTarget.classList.add('[&>svg]:rotate-180')
      this.expandTriggerTarget.setAttribute('aria-expanded', 'true')
    } else {
      this.expandableSectionTarget.classList.add('tw-hidden')
      this.expandableSectionTarget.classList.remove('grid')
      this.expandIconTarget.classList.remove('[&>svg]:rotate-180')
      this.expandTriggerTarget.setAttribute('aria-expanded', 'false')
    }
  }

  toggleBio(e = null) {
    e?.preventDefault()
    if (!this.hasBioCollapsedTarget || !this.hasBioExpandedTarget) return

    this.bioIsExpanded = !this.bioIsExpanded
    this.syncBioState()
  }

  syncBioState() {
    if (!this.hasBioCollapsedTarget || !this.hasBioExpandedTarget) return

    this.bioCollapsedTarget.classList.toggle('tw-hidden', this.bioIsExpanded)
    this.bioExpandedTarget.classList.toggle('tw-hidden', !this.bioIsExpanded)

    if (this.hasBioToggleLabelTarget) {
      this.bioToggleLabelTarget.textContent = this.bioIsExpanded
        ? 'See Less'
        : 'See More'
      this.bioToggleLabelTarget
        .closest('button')
        ?.setAttribute('aria-expanded', String(this.bioIsExpanded))
    }
  }
}
